module.exports = __webpack_public_path__ + "static/home-phone-tiny-6811044c2e21714eed058fae3ce2d8ab.png";